









































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MasalahKeperawatanSection extends Vue {
  @Prop({ default: () => [] }) readonly value!: string[];
  @Prop({ default: false }) readonly disabled!: boolean;

  items: string[] = [""];

  created() {
    if (Array.isArray(this.value) && this.value.length) {
      this.items = [...this.value];
    }
  }

  emitCleaned() {
    const cleaned = this.items.filter(s => (s || "").trim() !== "");
    this.$emit("input", cleaned);
  }

  setItem(idx: number, val: string) {
    this.$set(this.items, idx, val);
    this.emitCleaned();
  }

  addItem() {
    this.items.push("");
  }

  removeItem(idx: number) {
    this.items.splice(idx, 1);
    if (this.items.length === 0) this.items.push("");
    this.emitCleaned();
  }
}
